// extracted by mini-css-extract-plugin
export default {"pageTabs":"NavBar_pageTabs__Hju33","pageTab":"NavBar_pageTab__RAJAP","pageTab_active":"NavBar_pageTab_active__qk2kK","pageTab_inactive":"NavBar_pageTab_inactive__tU9eA"};